export const SET_NOTIFICATION_RANGE = 'SET_NOTIFICATION_RANGE';